<template>
  <div
    class="global-typography forms-list"
    :class="{
      'pt-9 mb-9': $vuetify.breakpoint.smAndUp,
      'pt-3 mb-3': $vuetify.breakpoint.xsOnly,
    }"
  >
    <v-row
      v-if="
        isSitecoreExperienceEditorOn ||
        (fields.SectionTitle && fields.SectionTitle.value && fields.SectionTitle.value !== '')
      "
      :class="{ 'pb-1': $vuetify.breakpoint.smAndUp, 'pb-3': $vuetify.breakpoint.xsOnly }"
    >
      <v-col col="12">
        <sc-text :field="fields.SectionTitle" tag="h2" />
      </v-col>
    </v-row>
    <v-row class="panel-header">
      <v-col cols="6">
        <sc-text :field="fields.LinkColumnHeader" />
      </v-col>
      <v-col cols="6">
        <sc-text :field="fields.DescriptionColumnHeader" />
      </v-col>
    </v-row>
    <v-row class="list-item-row" v-for="item in formListItems" :key="item.id">
      <v-col cols="6" class="list-item-link">
        <sc-link class="form-link" :field="item.FormLink"> </sc-link>
      </v-col>
      <v-col cols="6" class="list-item-description">
        <sc-rich-text :field="item.Description" />
      </v-col>
    </v-row>
    <div>
      <sc-rich-text :field="fields.FooterText" class="pt-4 formlist-footer" />
    </div>
  </div>
</template>

<script>
import { Link, Text, RichText, isExperienceEditorActive } from '@sitecore-jss/sitecore-jss-vue';
import SitecoreMultiline from '../Sitecore/SitecoreMultiline';
export default {
  name: 'FormList',
  data() {
    return {};
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    rendering: {
      type: Object,
    },
  },
  computed: {
    isSitecoreExperienceEditorOn() {
      // TODO may need to add other check like the preview mode
      return isExperienceEditorActive();
    },
    formListItems() {
      let list = [];
      let id = 1;
      if (this.fields.FormListItems) {
        this.fields.FormListItems.forEach((item) => {
          let formLink;
          if (item && item.fields && item.fields.Link) {
            formLink = item.fields.Link;
          }
          let descriptionField;
          if (item && item.fields && item.fields.Description) {
            descriptionField = item.fields.Description;
          }
          if (formLink) {
            list.push({
              id: id,
              FormLink: formLink,
              Description: descriptionField,
            });
            id++;
          }
        });
      }
      return list;
    },
  },
  methods: {},
  components: {
    ScLink: Link,
    ScText: Text,
    ScRichText: RichText,
    SitecoreMultiline,
  },
};
</script>
<style lang="scss" scoped>
.panel-header {
  background-color: unset !important;
  font-weight: map-get($font-weights, 'medium');
  border-bottom: 1px solid map-deep-get($colors, 'grey-mid', 'base');
  font-size: 18px;
  margin-left: 0px;
  margin-right: 0px;
}
.list-item-row {
  background-color: unset !important;
  border-bottom: 1px solid map-deep-get($colors, 'grey-mid', 'base');
  font-size: 16px;
  margin-left: 0px;
  margin-right: 0px;
  @media #{map-get($display-breakpoints, 'xs-only')} {
    font-size: 14px;
  }
  &:nth-child(odd) {
    background-color: map-deep-get($colors, 'white', 'base') !important;
  }
  &:last-of-type {
    border-bottom: none !important;
  }

  &::v-deep {
    .col p {
      margin-bottom: 0px !important;
    }
  }

  .list-item-link .form-link,
  .list-item-link .form-link:active,
  .list-item-link .form-link:hover {
    text-decoration: none;
  }
  .list-item-link .form-link:hover {
    text-decoration: underline;
  }
}
.formlist-footer {
  &::v-deep {
    p:first-of-type {
      margin-bottom: 2rem !important;
    }
  }
}
</style>
<style lang="scss">
.forms-list h1 {
  margin-bottom: 24px;
}
</style>